import { TripFrm } from '../pages/trip/trip_frm';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { CapitalizeDirective } from '../directives/mp.directive'

import { LoginPage } from '../pages/login/login'

import { AddressBrw } from '../pages/address/address_brw';
import { TripBrw } from '../pages/trip/trip_brw';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { AddressFrm } from '../pages/address/address_frm';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { AuthProvider } from '../providers/auth/auth';

import { Ng2GoogleChartsModule } from 'ng2-google-charts';

@NgModule({
  declarations: [
    MyApp,
    AddressBrw,
    AddressFrm,
    TripBrw,
    TripFrm,
    HomePage,
    TabsPage,
    LoginPage,
    CapitalizeDirective
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(environment.firebase),    // added for firebase (let op comma)
    AngularFirestoreModule.enablePersistence(),               // added for firebase (met offline support)
    AngularFireAuthModule,
    Ng2GoogleChartsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AddressBrw,
    AddressFrm,
    TripBrw,
    TripFrm,
    HomePage,
    TabsPage,
    LoginPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider
  ]
})
export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts